export const updateName = (name) => (dispatch) => {
  dispatch({
    type: 'UPDATE_EVENTS_CHECKIN_NAME',
    payload: name
  });
};

export const updateSelected = (id) => (dispatch, getState) => {
  dispatch({
    type: 'UPDATE_EVENTS_CHECKIN_SELECTED',
    payload: getState().events.checkin.selected === id ? 0 : id
  });
};

export const clearSelection = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_EVENTS_CHECKIN_SELECTED'
  });
};
